import { useState } from 'react';
import { supabase } from '@/lib/supabase';
import { compressImageToBase64 } from '@/lib/image';

export interface UploadResult {
  url?: string;
  error?: string;
}

export function useEditorImageUpload() {
  const [uploading, setUploading] = useState(false);

  const uploadFile = async (file: File, category: string = 'common'): Promise<UploadResult> => {
    const validTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      return { error: '仅支持 JPG/PNG/WebP/GIF 格式' };
    }
    if (file.size > 5 * 1024 * 1024) {
      return { error: '文件大小不能超过 5MB' };
    }

    setUploading(true);
    try {
      const base64 = await compressImageToBase64(file, 1400, 0.75);
      const apiBase = import.meta.env.VITE_PUBLIC_API_URL || '';
      const uploadUrl = `${apiBase}/api/upload-image`;

      const resp = await fetch(uploadUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          image: base64,
          filename: file.name.replace(/[^a-zA-Z0-9._-]/g, '_').toLowerCase(),
          contentType: 'image/jpeg',
          category,
        }),
      });
      const json = await resp.json();
      if (!resp.ok || json.error) {
        return { error: json.error || '上传失败' };
      }
      return { url: json.url };
    } catch (err: any) {
      return { error: err?.message || '上传失败' };
    } finally {
      setUploading(false);
    }
  };

  return { uploading, uploadFile };
}